import web from './web';
import localStorage from '@/utils/localStorage';

let wxdepartment = 'gtgj';

function clearOpenId(url) {
  let result, query;

  result = url;
  query = url.split('?')[1];

  if (query && query.indexOf('openid') !== -1) {
    query = query
      .split('&')
      .filter(item => {
        return item.indexOf('openid=') !== 0;
      })
      .join('&');

    result = url.split('?')[0];

    if (query) {
      result = result + '?' + query;
    }
  }

  return result;
}

export default {
  login({
          target_url,
          department = '' // gtgj or hbgj
        } = {}) {
    return new Promise(resolve => {
      let ru = target_url || window.location.href;
      ru = clearOpenId(ru);
      ru = encodeURIComponent(ru);

      let ruWithAuthTransfer = encodeURIComponent(
        /* global WEIXIN_AUTH_RU */
        `${WEIXIN_AUTH_RU}?ru=${encodeURIComponent(
          ru
        )}`
      );

      const onPageshow = e => {
        window.removeEventListener('pageshow', onPageshow);
        if (e.persisted) {
          resolve();
        }
      };
      window.addEventListener('pageshow', onPageshow);

      let __department = department || wxdepartment;
      localStorage.set('wxdepartment', __department); //缓存授权前对应的公众号平台 gtgj/hbgj
      /* global WEIXIN_AUTH_URL */
      let authUrl = `${WEIXIN_AUTH_URL}?department=${__department}&scope=snsapi_userinfo&redirect_uri=${ruWithAuthTransfer}&mode=bycode`;
      window.location.href = authUrl;
    });
  },

  // 目前只有航班公众号开通了微信支付,所以这里如果要调微信支付,需要调一次航班公众号静默授权获取openid
  loginHb({target_url} = {}) {
    return new Promise(resolve => {
      let ru = target_url || window.location.href;
      ru = clearOpenId(ru);
      ru = encodeURIComponent(ru);

      let ruWithAuthTransfer = encodeURIComponent(
        /* global WEIXIN_AUTH_RU */
        `${WEIXIN_AUTH_RU}?ru=${encodeURIComponent(
          ru
        )}`
      );

      const onPageshow = e => {
        window.removeEventListener('pageshow', onPageshow);
        if (e.persisted) {
          resolve();
        }
      };
      window.addEventListener('pageshow', onPageshow);

      localStorage.set('wxdepartment', 'hbgj'); //缓存授权前对应的公众号平台 gtgj/hbgj
      /* global WEIXIN_AUTH_URL */
      let authUrl = `${WEIXIN_AUTH_URL}?department=hbgj&scope=snsapi_base&redirect_uri=${ruWithAuthTransfer}&mode=default`;
      window.location.href = authUrl;
    });
  },

  logout() {
    return web.logout();
  },

  getToken() {
    return web.getToken();
  },

  refreshToken() {
    return web.refreshToken();
  }
};



// WEBPACK FOOTER //
// ./src/auth/weixin.js